import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import type { TrackingEvent } from '@openclassrooms/sdk-web';
import { useTrackingEventCreate } from '.';
export default function useTracker() {
  const $ = _c(2);
  const [publishOnAPI] = useTrackingEventCreate();
  let t0;
  if ($[0] !== publishOnAPI) {
    t0 = (eventName, t1) => {
      const {
        type: t2,
        data
      } = t1 === undefined ? {} : t1;
      const type = t2 === undefined ? "TRACK" : t2;
      const eventToTrack = {
        name: eventName,
        type,
        data
      };
      publishOnAPI(eventToTrack);
    };
    $[0] = publishOnAPI;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const track = t0;
  return track;
}